import { Filter, useSaveFilters } from '@ais-ui/websockets';
import { SaveFilterDialog } from './SaveFilterDialog';

interface UpdateFilterProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  filter: Filter;
}

export function EditFilter(props: UpdateFilterProps) {
  const { mutate } = useSaveFilters();

  return (
    <SaveFilterDialog
      showDialog={props.showDialog}
      setShowDialog={props.setShowDialog}
      action="edit"
      mutate={mutate}
      filter={props.filter}
      error={null}
    ></SaveFilterDialog>
  );
}
